<div
  class="bubble"
  #bubble
  role="status">
  <div class="progress-text">
    <span class="value">{{ current() | notRoundingBeautifyNumber: ('common.culture' | translate) }}</span>
    <span class="sep">/</span>
    <span class="total">{{ next() | notRoundingBeautifyNumber: ('common.culture' | translate) }}</span>
  </div>

  <div
    class="c-progress--prestige"
    progressBarIcon
    progressBarIconPos="left"
    theming
    themingGroup="progressline"
    themingAsset="prestige-logo"></div>

  <span
    class="arrow-bottom"
    aria-hidden="true"></span>
  <span
    class="arrow-side"
    aria-hidden="true"></span>
</div>
